import { render, staticRenderFns } from "./BoardsNavigation.vue?vue&type=template&id=5e900e4f&scoped=true&"
import script from "./BoardsNavigation.vue?vue&type=script&lang=js&"
export * from "./BoardsNavigation.vue?vue&type=script&lang=js&"
import style0 from "./BoardsNavigation.vue?vue&type=style&index=0&id=5e900e4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e900e4f",
  null
  
)

export default component.exports